"use strict";

jQuery(function ($) {
  // ボタン（クラス名：js-slider）をクリックした時の処理
  $('.js-slider').on('click', function () {
    // 1. 対象のimgタグを取得
    var $img = $(this).find('img');

    // 2. 画像パスの定義（ユーザー様の指定ファイル名）
    var defaultPath = '//lp.flexfits.jp/cdn/shop/files/wave_thin.svg'; // 元の画像
    var activePath = '//lp.flexfits.jp/cdn/shop/files/wave_thin.svg'; // 切り替え後の画像

    // 3. 現在の画像パスを確認して切り替え（トグル処理）
    // ※パスが完全一致するかどうかで判定します
    if ($img.attr('src') === defaultPath) {
      // 元の画像なら → 新しい画像（sp版）に変更
      $img.attr('src', activePath);
    } else {
      // 違う画像なら → 元の画像に戻す
      $img.attr('src', defaultPath);
    }
    var spmenu = $('#sp-menu');
    // （補足）ここでメニュー自体の開閉処理も同時に行うのが一般的です
     spmenu.toggleClass('is-active');
  });
  var $loading = $('#loading');
  var isTimeOver = false; // 3秒経過したかどうかのフラグ
  var isLoaded = false;   // 読み込みが完了したかどうかのフラグ

  // 1. タイマー設定（3秒後に実行）
  setTimeout(function () {
      isTimeOver = true;
      checkLoading(); // 状況をチェック
  }, 2000); // ここで時間を指定（2000ms = 2秒）

  // 2. ページの読み込み完了時に実行
  $(window).on('load', function () {
      isLoaded = true;
      checkLoading(); // 状況をチェック
  });

  // 判定用関数：両方の条件が揃ったらフェードアウト
  function checkLoading() {
      // 「3秒経過」かつ「読み込み完了」の場合のみ実行
      if (isTimeOver && isLoaded) {
          fadeOutLoading();
      }
  }

  // 実際に消す処理
  function fadeOutLoading() {
      if (!$loading.hasClass('is-hidden')) {
          $loading.addClass('is-hidden');
      }
  }
  /* ==============================================
     1. User's Voice Slider (Slick)
     ============================================== */
  $('.js-voice-slider').slick({
    dots: true,
    // 下部のドットナビを表示
    arrows: false,
    // 左右の矢印は非表示（デザインによる）
    infinite: true,
    // 無限ループ
    speed: 500,
    // 切り替え速度
    slidesToShow: 1,
    // PC時は3枚表示
    slidesToScroll: 1,
    // 1枚ずつスクロール
    autoplay: true,
    // 自動再生
    autoplaySpeed: 4000,
    centerMode: true,
    // 前後を少し見せる
    centerPadding: '13.8%',
    responsive: [{
      breakpoint: 768,
      // スマホサイズ
      settings: {
        slidesToShow: 1 // 1枚表示
      }
    }]
  });

  /* ==============================================
     2. FAQ Accordion (jQuery)
     ============================================== */
  $('.js-accordion-trigger').on('click', function () {
    // クリックされたボタンの親要素を取得
    var $item = $(this).closest('.p-faq__item');
    var $body = $item.find('.p-faq__body');

    // 開閉アニメーション
    $body.slideToggle(300);

    // アイコン回転などのためのクラス切り替え
    $item.toggleClass('is-active');

    // 排他制御（他を閉じる）が必要な場合は以下を有効化
    /*
    $('.p-faq__item').not($item).removeClass('is-active')
      .find('.p-faq__body').slideUp(300);
    */
  });

  /* ==============================================
     3. Smooth Scroll
     ============================================== */
  $('a[href^="#"]').on('click', function () {
    var href = $(this).attr('href');
    var target = $(href == "#" || href == "" ? 'html' : href);
    if (target.length) {
      // ヘッダー固定の場合はその高さを引く
      var headerHeight = $('.l-header').outerHeight() || 0;
      var position = target.offset().top - headerHeight;
      $('body,html').animate({
        scrollTop: position
      }, 500, 'swing');

      // PCナビゲーションのリンククリック時など、必要に応じてURLハッシュを更新しない
      return false;
    }
  });

  /* ==============================================
     4. Scroll Spy (PC Nav Active State)
     ============================================== */
  $(window).on('scroll', function () {
    var scrollPos = $(this).scrollTop();
    var windowHeight = $(this).height();
    $('section[id]').each(function () {
      var top = $(this).offset().top;
      var bottom = top + $(this).outerHeight();
      var id = $(this).attr('id');

      // 画面中央にセクションがかかっているか判定
      if (scrollPos > top - windowHeight / 2 && scrollPos < bottom - windowHeight / 2) {
        $('.p-pc-nav__link').removeClass('is-active');
        $('.p-pc-nav__link[href="#' + id + '"]').addClass('is-active');
      }
    });
  });
  /* ==============================================
      HowTo Tabs
      ============================================== */

  // HowToセクションのタブ切り替え
  $('.js-howto-tab').on('click', function () {
    // 1. クリックされたタブをアクティブにする
    $('.js-howto-tab').removeClass('is-active');
    $(this).addClass('is-active');

    // 2. 対応するパネルを表示する
    var target = $(this).data('target'); // "insert" または "remove"

    // パネルを一旦すべて隠してから、対象だけフェードイン
    $('.p-howto__panel').hide().removeClass('is-active');
    $('#' + target).fadeIn(300).addClass('is-active');
    return false;
  });


});